export enum LobbyPauseSettingsEnum {
    Unlimited = 0,
    Limited = 1,
    Disabled = 2
}